import styled from 'styled-components';

import Box from '@quintoandar/cozy-core/Box';
import tokens from '@quintoandar/cozy-theme/tokens/js';

const ChecklistTitleWrapper = styled(Box)`
  display: none;

  @media all and (min-width: ${tokens.grid.breakpoint.tablet.minWidth}) {
    display: block;
  }
`;

export default ChecklistTitleWrapper;
